module.exports = __webpack_public_path__ + "static/media/strawberry.60e2a001.jpg";